import { SURVEY_API_BASE } from '../../api/constants';

export function buildRecordQuestionActivityUrl(instanceId: string): string {
  const params = new URLSearchParams({ instanceId });
  return `${SURVEY_API_BASE}/cfm/recordQuestionActivityV2?${params.toString()}`;
}
